<template>
  <div :class="s.wrapper">
    <GlobalHeader v-if="!hideLayout" />
    <router-view />
    <GlobalFooter v-if="!hideLayout" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import { ContentsModal, MessagesModal, LoadingsModal } from '@/components/modal';
import {
  GlobalHeader,
  GlobalFooter,
} from '@/components/layouts';

export default {
  name: 'App',
  components: {
    GlobalHeader,
    GlobalFooter,
    //ContentsModal,
    //MessagesModal,
    //LoadingsModal,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'modal']),
    // ルートの meta.hideLayout が true ならヘッダー・フッターを出さない
    // 最初の遷移が終わるまでは matched が空なので出さない（短縮URLで一瞬ヘッダーが見えるのを防ぐ）
    hideLayout() {
      return this.$route.matched.length === 0 || this.$route.meta.hideLayout === true;
    },
  },
  created() {
    console.log('testtest');
    // ログインチェック
    // this.$store.dispatch('user/login/check');
    // backend共通マスターデータ取得
    this.$store.dispatch('helper/getMaster');
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" module="s">
.wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>

<style lang="scss">
//@import './assets/scss/_mq.scss';
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_fonts.scss';
//@import './assets/scss/modal.scss';
@import '@/assets/scss/style.scss';
</style>
